export const CLEAR_DATA = 'CLEAR_DATA';
